module.exports = __webpack_public_path__ + "static/img/icon_snb_my_dashboard_hover.1398286.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_snb_my_dashboard_hover.svg
// module id = KZ1d
// module chunks = 10